import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.TaskPage.components.EventsWidget.title',
    defaultMessage: 'Events',
  },
})
